export default {
  googleKey: '68702783717-lbhtajh84i4gvak3fo8hlkk474src7g8.apps.googleusercontent.com'
};